import { LABEL_COLOR, LABEL_SIZE, LABEL_STYLE, LABEL_TYPE } from "./types";

export const labelSize = {
  [LABEL_SIZE.XLARGE]: "h-10 flex items-center gap-x-1.5 px-3",
  [LABEL_SIZE.LARGE]: "h-8 flex items-center gap-x-1 px-2.5",
  [LABEL_SIZE.MEDIUM]: "h-6 flex items-center gap-x-1.5 px-1.5",
  [LABEL_SIZE.SMALL]: "h-5 flex items-center body-sm gap-x-1 px-2",
  [LABEL_SIZE.XSMALL]: "h-4 flex items-center gap-x-0.5 px-px",
};

export const labelType = {
  [LABEL_TYPE.ROUND]: "rounded-full",
  [LABEL_TYPE.SQUARE]: "rounded-4",
};

export const labelClass = {
  [LABEL_STYLE.FILL]: {
    [LABEL_COLOR.DEFAULT]: "bg-fds-inverse-secondary text-fds-on-inverse",
    [LABEL_COLOR.BRAND]: "bg-fds-brand text-fds-on-brand",
    [LABEL_COLOR.ACCENT]: "bg-fds-accent text-fds-on-accent",
    [LABEL_COLOR.DANGER]: "bg-fds-danger text-fds-on-danger",
    [LABEL_COLOR.SUCCESS]: "bg-fds-success text-fds-on-success",
    [LABEL_COLOR.WARNING]: "bg-fds-warning text-fds-on-warning",
    [LABEL_COLOR.INFO]: "bg-fds-info text-fds-on-info",
  },
  [LABEL_STYLE.LIGHT]: {
    [LABEL_COLOR.DEFAULT]: "bg-fds-secondary text-fds-primary",
    [LABEL_COLOR.BRAND]: "bg-fds-brand-light text-fds-on-brand-light",
    [LABEL_COLOR.ACCENT]: "bg-fds-accent-light text-fds-on-accent-light",
    [LABEL_COLOR.DANGER]: "bg-fds-danger-light text-fds-on-danger-light",
    [LABEL_COLOR.SUCCESS]: "bg-fds-success-light text-fds-on-success-light",
    [LABEL_COLOR.WARNING]:
      "bg-fds-warning-light text-fds-on-warning-light fill-fds-icon-on-warning-light",
    [LABEL_COLOR.INFO]: "bg-fds-info-light text-fds-on-info-light",
  },
  [LABEL_STYLE.TEXT]: {
    [LABEL_COLOR.DEFAULT]: "text-fds-primary",
    [LABEL_COLOR.BRAND]: "text-fds-brand",
    [LABEL_COLOR.ACCENT]: "text-fds-accent",
    [LABEL_COLOR.DANGER]: "text-fds-danger",
    [LABEL_COLOR.SUCCESS]: "text-fds-success",
    [LABEL_COLOR.WARNING]: "text-fds-warning",
    [LABEL_COLOR.INFO]: "text-fds-info",
  },
  [LABEL_STYLE.OUTLINE]: {
    [LABEL_COLOR.DEFAULT]: "border border-fds-default",
    [LABEL_COLOR.BRAND]: "border border-fds-brand",
    [LABEL_COLOR.ACCENT]: "border border-fds-accent",
    [LABEL_COLOR.DANGER]: "border border-fds-danger",
    [LABEL_COLOR.SUCCESS]:
      "border border-fds-success text-fds-success hover:text-fds-success-hover active:bg-success-light active:text-success-select active:border-fds-success-select",
    [LABEL_COLOR.WARNING]:
      "border border-fds-warning text-fds-warning hover:text-fds-warning-hover active:bg-warning-light active:text-warning-select active:border-fds-warning-select",
    [LABEL_COLOR.INFO]: "border border-fds-info",
  },
};
